import useCapabilities, { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";

export const MEMBERSHIP_SERVICES_TAB = {
  label: "Membership Services",
  to: "/analytics/interactions/membership-services"
} as const;

export const CAREER_SERVICES_TAB = {
  label: "Career Services",
  to: "/analytics/interactions/career-services"
} as const;

// Single owner for per-tab usability: the avatar menu, the analytics layout,
// and the index redirect all read these gates so they can never disagree.
export function useInteractionAnalyticsTabs() {
  const canUseMembershipTab = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPeopleInteractions
  });
  const canUseCareerTab = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewCareerServicesDashboard
  });
  return { canUseMembershipTab, canUseCareerTab };
}

export function useFirstUsableAnalyticsTab(): string | null {
  const { loaded } = useCapabilities();
  const { canUseMembershipTab, canUseCareerTab } = useInteractionAnalyticsTabs();
  if (!loaded) return null;
  if (canUseMembershipTab) return MEMBERSHIP_SERVICES_TAB.to;
  if (canUseCareerTab) return CAREER_SERVICES_TAB.to;
  return null;
}
